import { FileText } from "lucide-react";
import { Input } from "@/components/ui/input";
import { DayPick, RangePick } from "./DatePick";
import { shortDate } from "./dates";

const inputCls = "bg-slate-800 border-slate-600";

function Field({ label, children, hint }) {
  return (
    <div>
      <label className="text-xs text-muted-foreground">{label}</label>
      <div className="mt-1">{children}</div>
      {hint && <p className="text-[11px] text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

export default function PlanInfoCard({ header, setHeader }) {
  const set = (patch) => setHeader((h) => ({ ...h, ...patch }));
  const rangeHint = header.weekStart
    ? `Plans will be labeled by weekday, e.g. ${shortDate(header.weekStart)} → each day gets its own page.`
    : "The school days covered by this weekly plan (Mon–Fri only).";
  return (
    <div className="hq-glass rounded-2xl p-4" data-testid="lp-plan-info">
      <p className="text-sm font-medium text-slate-200 mb-3 flex items-center gap-2"><FileText className="w-4 h-4 text-[#22D3EE]" /> Plan Information</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="School Name"><Input data-testid="lp-school" value={header.school} onChange={(e) => set({ school: e.target.value })} placeholder="Batesville Junior High School" className={inputCls} /></Field>
        <Field label="Teacher Name"><Input data-testid="lp-teacher" value={header.teacher} onChange={(e) => set({ teacher: e.target.value })} placeholder="Your name" className={inputCls} /></Field>
        <Field label="Class Name"><Input data-testid="lp-class" value={header.className} onChange={(e) => set({ className: e.target.value })} placeholder="e.g. Cyber Foundations 2" className={inputCls} /></Field>
        <Field label="Minutes per period"><Input data-testid="lp-period" value={header.period} onChange={(e) => set({ period: e.target.value })} className={inputCls} /></Field>
        <Field label="Week Date Range" hint={rangeHint}>
          <RangePick testId="lp-week-range" start={header.weekStart} end={header.weekEnd} onChange={(s, e) => set({ weekStart: s, weekEnd: e })} />
        </Field>
        <Field label="Next Major Assessment" hint="Fills the “Next Major Assessment” box on every day.">
          <DayPick testId="lp-next-assessment" value={header.nextAssessmentDate || ""} onChange={(v) => set({ nextAssessmentDate: v, nextAssessment: v ? shortDate(v) : "" })} placeholder="Pick a date" />
          <Input data-testid="lp-next-assessment-text" value={header.nextAssessment || ""} onChange={(e) => set({ nextAssessment: e.target.value })} placeholder="or type it, e.g. Checkpoint 1 · 9/18/2026" className={`${inputCls} mt-2`} />
        </Field>
      </div>
    </div>
  );
}
